module.exports = __webpack_public_path__ + "img/train-9.b25dca86.jpg";